import { SortOrder } from "../sort-order";

export class DecoderFilters {
  name: string;
  type: string;
  tenantUuids: string[];
  sortField: string;
  sortOrder: SortOrder;
}
